function validateEmail(email: string): boolean {
  if (email.length < 5 || email.length > 254) return false;

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) return false;

  const [localPart, domainPart] = email.split('@');
  if (!localPart || !domainPart) return false;

  const domainParts = domainPart?.split('.');
  if (domainParts.length < 2) return false;

  if (
    domainParts.some(
      (part) => !/^[a-zA-Z0-9-]+$/.test(part) || part.length === 0,
    )
  )
    return false;

  return true;
}

export default validateEmail;
